import { msLocalStorage, msSessionStorage } from '@common/utils/cache';
import { fetchChannelMsg } from '@common/services/common';

export default (): Promise<void> => {
  return new Promise(async (resolve, reject) => {
    try {
      if (
        msSessionStorage.get('PUBLIC_APPKEY') &&
        msSessionStorage.get('PUBLIC_COOPERATORID') &&
        msSessionStorage.get('PUBLIC_PRODUCTCODE')
      ) {
        resolve();
        return;
      }
      const channelRes = await fetchChannelMsg();
      const { appKey, cooperatorId, productCode } = channelRes;

      // 存储appKey
      if (appKey) {
        msSessionStorage.set('PUBLIC_APPKEY', appKey);
        msLocalStorage.set('PUBLIC_APPKEY', appKey);
      }
      // 存储渠道编码
      if (cooperatorId) {
        msSessionStorage.set('PUBLIC_COOPERATORID', cooperatorId);
        msLocalStorage.set('PUBLIC_COOPERATORID', cooperatorId);
      }
      // 存储产品编码
      if (productCode) {
        msSessionStorage.set('PUBLIC_PRODUCTCODE', productCode);
        msLocalStorage.set('PUBLIC_PRODUCTCODE', productCode);
      }
      resolve();
    } catch (err) {
      reject();
    }
  });
};
